import * as React from 'react'

const SvgMagnifyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 13.125h-5V2.5h11.25v5H15v-5c0-.69-.56-1.25-1.25-1.25H2.5c-.69 0-1.25.56-1.25 1.25v10.625c0 .69.56 1.25 1.25 1.25h5v-1.25zm11.25 4.738l-1.944-1.944a3.75 3.75 0 10-.887.887l1.944 1.944.887-.887zm-5-1.613a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
      fill="#163250"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4h6.25v1.25H4V4zm0 2.5h6.25v1.25H4V6.5zM4 9h3.75v1.25H4V9z"
      fill="#163250"
    />
  </svg>
)

export default SvgMagnifyIcon
